import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { CrudlStatus } from "../../../common/config/AppConstants";
import { BPMInput } from "../../Common/BPMInput";
import * as format from "../../../common/FormatFunctions";
import { ListValueGenerator } from "../../Common/ListValueGenerator";
import { LoadScreen } from "../../Common/LoadScreen";
import { FileUploader } from "../../Common/FileUploader";
import { CCSelector } from "../../Catalogues/legacy/CCSelector";
import { PartDisplay } from "../../Part/UI/PartDisplay";
import { ProductDisplay } from "./ProductDisplay";
import { Flows } from "../../Flows/Flows";
export class ProductCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <React.Fragment>
        <pr.ScrollPanel
          ref={el => (this.layoutMenuScroller = el)}
          style={{ height: "85%", borderColor: "transparent" }}
        >
          <div className="ui-g">
            <h2>
              {format.capitalize(this.props.crudlState.display) + " Product"}
            </h2>
            <div className="ui-g-12"></div>
            {this.props.loading === true && <LoadScreen />}
            {this.props.loading !== true && (
              <React.Fragment>
                <div className="ui-g-1"></div>
                <div className="ui-g-5">
                  <div className="ui-g-12">
                    <FileUploader
                      fileType="IMAGE"
                      label="Upload Image"
                      accept="image/*"
                      currentFiles={this.props.editedObject.imageUrls}
                      updateFiles={this.props.updateValue}
                      limited={true}
                      field={"imageUrls"}
                    />
                  </div>
                </div>
                <div className="ui-g-5">
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Type *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.Dropdown
                        value={this.props.editedObject.operationalType || ""}
                        disabled={true}
                        options={this.props.operationalTypeOptions}
                        onChange={e => {
                          this.props.updateValue("operationalType", e.value);
                        }}
                        filter={true}
                        filterBy="label"
                        filterPlaceholder="Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Product Type *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.Dropdown
                        value={this.props.editedObject.productType || ""}
                        options={this.props.productTypeOptions}
                        onChange={e => {
                          this.props.updateValue("productType", e.value);
                        }}
                        filter={true}
                        filterBy="label"
                        filterPlaceholder="Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Attribute Set *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.Dropdown
                        value={this.props.editedObject.attributeSetId || ""}
                        options={this.props.attributeSetMap}
                        onChange={e => {
                          this.props.updateValue("attributeSetId", e.value);
                          this.props.selectAttributeSet(e.value);
                        }}
                        filter={true}
                        filterBy="label"
                        filterPlaceholder="Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>

                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">SKU *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.sku}
                        onChange={e =>
                          this.props.updateValue("sku", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                </div>

                <div className="ui-g-1"></div>
                <div className="ui-g-1"></div>
                <div className="ui-g-10">
                  {this.props.editedObject.attributeSetId && (
                    <pr.TabView onTabChange={e => {}}>
                      <pr.TabPanel header="Details">
                        <React.Fragment>
                          <div className="ui-g-6">
                            <div className="ui-g-12">
                              <div className="ui-g-3">
                                <label className="input-label">Name *</label>
                              </div>

                              <div className="ui-g-9">
                                <pr.InputText
                                  required={true}
                                  value={this.props.editedObject.name}
                                  onChange={e =>
                                    this.props.updateValue(
                                      "name",
                                      e.target.value
                                    )
                                  }
                                  disabled={
                                    this.props.crudlState === CrudlStatus.VIEW
                                  }
                                />
                              </div>
                            </div>
                            <div className="ui-g-12">
                              <div className="ui-g-3">
                                <label className="input-label">
                                  Description *
                                </label>
                              </div>

                              <div className="ui-g-9">
                                <pr.InputText
                                  required={true}
                                  value={
                                    this.props.editedObject.shortDescription
                                  }
                                  onChange={e =>
                                    this.props.updateValue(
                                      "shortDescription",
                                      e.target.value
                                    )
                                  }
                                  disabled={
                                    this.props.crudlState === CrudlStatus.VIEW
                                  }
                                />
                              </div>
                            </div>
                            <div className="ui-g-12">
                              <div className="ui-g-3">
                                <label className="input-label">
                                  Long Description
                                </label>
                              </div>

                              <div className="ui-g-9">
                                <textarea
                                  id={
                                    this.props.editedObject.longDescription +
                                    " Details"
                                  }
                                  rows={5}
                                  placeholder=""
                                  value={
                                    this.props.editedObject.longDescription
                                  }
                                  onChange={e => {
                                    this.props.updateValue(
                                      "longDescription",
                                      e.target.value
                                    );
                                  }}
                                  disabled={
                                    this.props.crudlState === CrudlStatus.VIEW
                                  }
                                  style={{
                                    width: "100%",
                                    backgroundColor: "transparent"
                                  }}
                                />
                              </div>
                            </div>
                            {this.props.editedObject.productType ===
                            "SUBASSEMBLY" ? (
                              <label />
                            ) : (
                              <CCSelector
                                type={"GLOBAL"}
                                updateState={this.props.updateValue}
                                catalogueId={
                                  this.props.editedObject.catalogueId
                                }
                                categoryId={this.props.editedObject.categoryId}
                              />
                            )}
                          </div>
                          <div className="ui-g-6">
                            {this.attributeListToFields()}
                          </div>
                        </React.Fragment>
                      </pr.TabPanel>
                      <pr.TabPanel header="Procurement">
                        <div className="ui-g-2"></div>
                        <div className="ui-g-8">
                          <div className="ui-g-12">
                            <div className="ui-g-3">
                              <label className="input-label">Stock Type</label>
                            </div>

                            <div className="ui-g-9">
                              <pr.Dropdown
                                value={this.props.editedObject.stockType || ""}
                                options={this.props.stockTypeOptions}
                                onChange={e => {
                                  this.props.updateValue("stockType", e.value);
                                }}
                                filter={true}
                                filterBy="label"
                                filterPlaceholder="Search"
                                style={{ width: "100%" }}
                              />
                            </div>
                          </div>
                          {this.props.editedObject.stockType ===
                            "PURCHASED" && (
                            <div className="ui-g-12">
                              <div className="ui-g-3">
                                <label className="input-label">Supplier</label>
                              </div>

                              <div className="ui-g-9">
                                <pr.Dropdown
                                  value={
                                    this.props.editedObject.supplierId || ""
                                  }
                                  options={this.props.supplierMap}
                                  onChange={e => {
                                    this.props.updateValue(
                                      "supplierId",
                                      e.value
                                    );
                                  }}
                                  filter={true}
                                  filterBy="label"
                                  filterPlaceholder="Search"
                                  style={{ width: "100%" }}
                                />
                              </div>
                            </div>
                          )}
                          <div className="ui-g-12">
                            <div className="ui-g-3">
                              <label className="input-label">Price</label>
                            </div>

                            <div className="ui-g-9">
                              <pr.InputText
                                keyfilter={"money"}
                                value={this.props.editedObject.price}
                                onChange={e =>
                                  this.props.updateValue(
                                    "price",
                                    e.target.value
                                  )
                                }
                                disabled={
                                  this.props.crudlState === CrudlStatus.VIEW
                                }
                              />
                            </div>
                          </div>
                          <div className="ui-g-12">
                            <div className="ui-g-3">
                              <label className="input-label">Cost</label>
                            </div>

                            <div className="ui-g-9">
                              <pr.InputText
                                keyfilter={"money"}
                                value={this.props.editedObject.cost}
                                onChange={e =>
                                  this.props.updateValue("cost", e.target.value)
                                }
                                disabled={
                                  this.props.crudlState === CrudlStatus.VIEW
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </pr.TabPanel>
                      <pr.TabPanel header="Bill Of Materials">
                        <div className="ui-g-12">
                          <div>
                            <pr.Dialog
                              visible={this.props.componentModalView}
                              style={{ width: "100vw" }}
                              modal={false}
                              onHide={e => this.props.hideComponentEditor()}
                              header="Select Componenets"
                              blockScroll={true}
                              maximizable={true}
                            >
                              <div className="c-dialog-overflow">
                                {/* {this.partSelectionTable()} */}
                                <pr.DataTable
                                  ref={el => {
                                    this.dt = el;
                                  }}
                                  reorderableColumns={false}
                                  selectionMode="single"
                                  onSelectionChange={e => {}}
                                  value={this.props.componentList}
                                  dataKey="id"
                                  header={
                                    <div>
                                      <label className="header-label">
                                        Components
                                      </label>
                                    </div>
                                  }
                                  emptyMessage="No Components"
                                  rows={100}
                                  autoLayout={true}
                                  paginator={true}
                                  alwaysShowPaginator={true}
                                >
                                  {this.getComponentColumns()}
                                  <pr.Column
                                    key="add"
                                    body={this.getComponentAddTemplate}
                                    style={{
                                      textAlign: "center",
                                      width: "8em"
                                    }}
                                  />
                                </pr.DataTable>{" "}
                              </div>
                            </pr.Dialog>
                          </div>
                          <pr.TreeTable
                            // ref={el => {
                            //   this.dt = el;
                            // }}
                            // reorderableColumns={false}
                            // selectionMode="single"
                            //onSelectionChange={e => {}}
                            // expandedRows={this.props.componentExpandedRows}
                            // onRowToggle={e =>
                            //   this.props.updateState(
                            //     "componentExpandedRows",
                            //     e.data
                            //   )
                            // }
                            // rowExpansionTemplate={
                            //   this.componentSelectionTemplate
                            // }
                            value={this.props.editedObject.treeTableComponents}
                            selectionMode="single"
                            selectionKeys={this.state.selectedComponentKey}
                            selectionChange={e => {
                              console.log(e.selection.data);
                              if (!e.selection.key.includes("child")) {
                                this.setState({
                                  selectedComponentKey: e.selection.key,
                                  selectedComponent: e.selection.data
                                });
                              } else {
                                this.setState({
                                  selectedComponentKey: null,
                                  selectedComponent: null
                                });
                              }
                            }}
                            footer="&nbsp;"
                            header={
                              <div className="ui-g">
                                <div className="ui-g-12">
                                  <pr.Button
                                    type="button"
                                    icon="pi pi-trash"
                                    label={"Remove Component"}
                                    className="p-button-success"
                                    onClick={e => {
                                      this.props.removeComponent(
                                        format.deepCopy(
                                          this.state.selectedComponent
                                        )
                                      );
                                      this.setState({
                                        selectedComponentKey: null,
                                        selectedComponent: null
                                      });
                                    }}
                                    style={
                                      this.state.selectedComponent
                                        ? {
                                            marginRight: ".5em",
                                            float: "right"
                                          }
                                        : { display: "none" }
                                    }
                                  ></pr.Button>
                                  <pr.Button
                                    className="p-button-success"
                                    icon="pi pi-plus"
                                    label={"Add Component"}
                                    onClick={() => {
                                      this.props.updateState(
                                        "componentModalView",
                                        true
                                      );
                                    }}
                                    style={{ float: "right" }}
                                  />
                                </div>
                                <div className="ui-g-12">
                                  <label className="header-label"></label>
                                </div>
                              </div>
                            }
                          >
                            <pr.Column field="name" header="Name" expander />
                            <pr.Column
                              field="shortDescription"
                              header="Description"
                            />
                            <pr.Column
                              field="componentType"
                              header="Component"
                            />
                            <pr.Column field="quantity" header="Quantity" />
                          </pr.TreeTable>
                        </div>
                      </pr.TabPanel>
                      <pr.TabPanel header="Operations and Routings Details">
                        <Flows
                          type={"PRODUCT"}
                          crudlState={this.props.crudlState}
                          typeDisplay="products"
                          componentList={
                            this.props.editedObject.selectedComponents
                          }
                          allComponents={this.props.componentList}
                          id={this.props.editedObject.id}
                          stationMap={this.props.stationMap}
                          currentFlowBean={this.props.editedObject.flowRequest}
                          updateValue={this.props.updateValue}
                          crudlExecute={this.props.crudlExecute}
                        />
                      </pr.TabPanel>
                    </pr.TabView>
                  )}
                </div>
                {/* <div className="ui-g-1"></div> */}
                {/*        
    
                <div className="ui-g-5"></div> */}
              </React.Fragment>
            )}
          </div>
        </pr.ScrollPanel>

        <div className="Container">
          <pr.Toolbar
            className="bottom-bar"
            style={{
              backgroundColor: "transparent",
              borderColor: "transparent"
            }}
          >
            <div className="p-toolbar-group-left">
              <pr.Button
                icon="pi pi-times"
                label={"Cancel"}
                className="p-button-danger"
                style={{
                  marginRight: ".25em",
                  float: "left",
                  backgroundColor: "#043066"
                }}
                onClick={() => {
                  this.props.validateChanges();
                }}
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-trash"
                }
                label={"Delete"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.DELETE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState !== CrudlStatus.CREATE &&
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save"}
                onClick={e => {
                  this.props.crudlExecute(true);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save and Close"}
                onClick={() => {
                  this.props.crudlExecute(false);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-pencil"
                }
                label={"Edit"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.UPDATE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState === CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
            </div>
          </pr.Toolbar>
        </div>
      </React.Fragment>
    );
  }
  actionTemplate(node, column) {
    return (
      <div>
        <pr.Button
          type="button"
          icon="pi pi-search"
          className="p-button-success"
          style={{ marginRight: ".5em" }}
        ></pr.Button>
        <pr.Button
          type="button"
          icon="pi pi-pencil"
          className="p-button-warning"
        ></pr.Button>
      </div>
    );
  }
  convertListToTreeTable = (fullComponentList, selectedComponentList) => {
    var componentTreeList = [];
    var index = 0;
    if (format.isNotNull(selectedComponentList)) {
      selectedComponentList.forEach(element => {
        var treeRow = {};
        treeRow.key = index.toString();
        treeRow.data = format.deepCopy(element);

        if (element.componentType === "PART") {
          treeRow.children = [];
        }
        if (element.componentType === "SUB-ASSEMBLY") {
          var children = [];
          var localIndex = 0;

          if (format.isNotNull(element.partProductJson)) {
            var partProduct = JSON.parse(element.partProductJson);
            if (format.isNotNull(partProduct.parts)) {
              partProduct.parts.forEach(part => {
                fullComponentList.forEach(component => {
                  if (part.id === component.id) {
                    var treeRow = {};
                    treeRow.key = treeRow.key + localIndex.toString();
                    treeRow.data = format.deepCopy(component);
                    treeRow.children = [];
                    children.push(treeRow);
                    localIndex++;
                  }
                });
              });
            }
            if (format.isNotNull(partProduct.products)) {
              partProduct.products.forEach(sub => {
                fullComponentList.forEach(component => {
                  if (sub.id === component.id) {
                    var treeRow = {};
                    treeRow.key = localIndex;
                    treeRow.data = format.deepCopy(component);
                    treeRow.children = [];
                    children.push(treeRow);
                    localIndex++;
                  }
                });
              });
            }
          }
          treeRow.expanded = true;
          treeRow.children = children;
        }

        componentTreeList.push(treeRow);
        index++;
      });
    }
    return componentTreeList;
  };
  getComponentColumns = () => {
    console.log(this.props);
    var allColumns = [];
    // allColumns.push(
    //   <pr.Column
    //     key="expander"
    //     expander={true}
    //     style={{ width: "5em", float: "middle" }}
    //   />
    // );
    if (format.isNotNull(this.props.componentColumns)) {
      let columns = this.props.componentColumns.map((col, i) => {
        return (
          <pr.Column
            key={col.field}
            field={col.field}
            header={col.header}
            sortable={col.sortable}
            filter={col.filter}
            filterMatchMode={col.filterMatchMode}
            style={col.style}
          />
        );
      });
      columns.push(
        <pr.Column
          field="quantity"
          editor={this.componentQuantityEditor}
          header="Quantity"
          sortable={true}
          filter={true}
          style={{ overflow: "auto" }}
        />
      );

      //  allColumns.push(pr.getExpanderColumn());
      columns.forEach(e => {
        allColumns.push(e);
      });
    }
    return allColumns;
  };

  componentSelectionTemplate = bean => {
    if (bean.componentType === "PART") {
      return <PartDisplay data={bean} />;
    }
    if (bean.componentType === "SUB-ASSEMBLY") {
      return <ProductDisplay data={bean} />;
    }
  };
  componentQuantityEditor = props => {
    return this.componentInputTextEditor(props, "quantity");
  };
  componentInputTextEditor = (props, field) => {
    return (
      <pr.InputText
        type="text"
        keyfilter="int"
        value={props.rowData[field] || ""}
        onChange={e =>
          this.onComponentEditorValueChange(
            props.rowIndex,
            props.field,
            e.target.value
          )
        }
      />
    );
  };
  onComponentEditorValueChange = (row, field, value) => {
    let updatedList = this.props.componentList;
    updatedList[row][field] = value;

    this.props.updateState("componentList", updatedList);
  };

  getComponentAddTemplate = (rowData, column) => {
    if (
      rowData.quantity === 0 ||
      rowData.quantity === undefined ||
      rowData.quantty === ""
    ) {
      return <div></div>;
    } else {
      if (rowData.quantityAdded) {
        return (
          <div>
            <pr.Button
              type="button"
              icon="pi pi-check"
              className="p-button-success"
              onClick={() => {}}
              // onClick={() => {
              //   this.setState({ partSelected: rowData, partAdded: true });
              // }}
              style={{ marginRight: ".5em", background: "green" }}
            ></pr.Button>
          </div>
        );
      } else {
        return (
          <div>
            <pr.Button
              type="button"
              icon="pi pi-plus"
              className="p-button-success"
              onClick={f => this.props.updateComponentSelected(f, rowData)}
              // onClick={() => {
              //   this.setState({ partSelected: rowData, partAdded: true });
              // }}
              style={{ marginRight: ".5em" }}
            ></pr.Button>
          </div>
        );
      }
    }
  };

  getComponentRemoveTemplate = (node, column) => {
    return (
      <div>
        <pr.Button
          type="button"
          icon="pi pi-trash"
          className="p-button-success"
          onClick={e => {
            this.props.removeComponent(node.data);
          }}
          style={{ marginRight: ".5em" }}
        ></pr.Button>
      </div>
    );
  };
  attributeListToFields = () => {
    let componentArray = [];
    let i = 0;
    console.log(this.props.selectedAttributeSet);
    if (this.props.selectedAttributeSet !== undefined) {
      if (this.props.selectedAttributeSet.attributeBeanList !== undefined) {
        this.props.selectedAttributeSet.attributeBeanList.forEach(e => {
          if (e.type === "LIST") {
            componentArray[i] = (
              <div className="ui-g-12" key={i}>
                <div className="ui-g-3">
                  <label className="input-label">{e.name}</label>
                </div>
                <div className="ui-g-9">
                  <pr.Dropdown
                    value={
                      JSON.parse(this.props.editedObject.customPropertiesJson)[
                        e.name
                      ] || ""
                    }
                    options={pr.getDropdownOptionsFromList(e.acceptedValues)}
                    onChange={f => {
                      this.props.updateAttributeProperties(e.name, f.value);
                    }}
                    filter={true}
                    filterBy="label"
                    filterPlaceholder="Search"
                    style={{ width: "100%" }}
                  />
                </div>
                {/* <div className="ui-g-12 ui-md-4" style={{ paddingTop: "2em" }}>
                
                  {this.props.editedObject.operationalType === "CONFIGURABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeConfigurable[e.name]}
                        onChange={f => {
                          this.updateConfigList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Configurable?
                      </label>
                    </div>
                  )}
                  {this.props.editedObject.operationalType === "VARIABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeVariable[e.name].checked}
                        onChange={f => {
                          this.updateVariableList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Variable?
                      </label>
                    </div>
                  )}
                </div> */}
              </div>
            );
          }

          if (e.type === "INPUT") {
            componentArray[i] = (
              <div className="ui-g-12" key={i}>
                <div className="ui-g-3">
                  <label className="input-label">{e.name}</label>
                </div>
                <div className="ui-g-9">
                  <pr.InputText
                    id={e.name + " Attribute"}
                    value={
                      JSON.parse(this.props.editedObject.customPropertiesJson)[
                        e.name
                      ] || ""
                    }
                    onChange={f => {
                      this.props.updateAttributeProperties(
                        e.name,
                        f.target.value
                      );
                    }}
                  />
                </div>
                {/* <div className="ui-g-12 ui-md-4" style={{ paddingTop: "2em" }}>
                  <b>{e.unitOfMeasurement || ""}</b>
                </div> */}
                {/* <div className="ui-g-12 ui-md-4" style={{ paddingTop: "2em" }}>
        
                  {s.editedPart.operationalType === "CONFIGURABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeConfigurable[e.name]}
                        onChange={f => {
                          this.updateConfigList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Configurable?
                      </label>
                    </div>
                  )}
                  {s.editedPart.operationalType === "VARIABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeVariable[e.name].checked}
                        onChange={f => {
                          this.updateVariableList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Variable?
                      </label>

                      {this.state.attributeVariable[e.name] && (
                        <div className="ui-g-12">
                          {this.getAcceptedValues(e.name)}
                        </div>
                      )}
                    </div>
                  )}
                </div> */}
              </div>
            );
          }

          i++;
        });
      }
    }

    return componentArray;
  };
}



// WEBPACK FOOTER //
// ./src/components/Products/UI/ProductCard.js